export default {
  title: 'Beregner for servicegebyrindtægt',
  description: 'Beregn, hvad servicegebyret indbringer hver måned. Tallene opdateres, mens du skriver.',
  authoritative:
    'Procentsatsen og det maksimale gebyr nedenfor er de indstillinger, der bliver anvendt. Gennemsnitlig ordreværdi og månedlig GMV er kun estimater.',
  off_notice:
    'Servicegebyret er slået fra på denne restaurant, så det indbringer endnu ikke noget. Gem et gebyr ovenfor for at slå det til.',
  fields: {
    recommended: 'Anbefalet: {{value}}',
    aov: {
      label: 'Gennemsnitlig ordreværdi',
      help: 'Typisk kurvstørrelse i dit onlinebestillingssystem.',
      placeholder: 'fx 32,50',
    },
    percentage: {
      label: 'Servicegebyr i procent',
      help: 'Mellem {{min}}% og {{max}}%.',
    },
    max_amount: {
      label: 'Maksimalt gebyr pr. ordre',
      help: '{{max}} er platformens maksimum.',
      below_min: 'Det maksimale gebyr skal være mindst {{min}}.',
    },
    monthly_gmv: {
      label: 'Månedlig GMV',
      help: 'Samlet ordreværdi behandlet pr. måned.',
      placeholder: 'fx 85000',
    },
  },
  outputs: {
    partner_revenue: 'Din anslåede månedlige indtjening',
    approximate: 'Omtrentligt tal baseret på værdierne ovenfor – den faktiske indtjening vil variere.',
    estimate_inputs: 'Baseret på din anslåede ordreværdi og GMV – den faktiske indtjening vil variere.',
    share: 'Det er din andel på {{share}}% af det samlede opkrævede servicegebyr.',
    total_collected: 'Samlet servicegebyr opkrævet fra gæster ved betaling',
    total_collected_note: '– betalt af gæster, ikke yderligere indtægt oven i tallet ovenfor.',
    effective_rate: 'Effektiv gebyrsats på tværs af alle ordrer',
  },
};
